import React from "react";
import classNames from "classnames";
import { connect } from 'react-redux';

class Pace extends React.Component {
    render () {
        const paces = Object.entries(this.props.paces);
        let percent = 0;
        paces.map((pace) => {
            percent += (pace[1].percentDown || pace[1].percentUp);
        });
        percent = (percent / (100 * paces.length)) || 0;
        return (
            <div className={classNames("pace")}>
                <div className={classNames("pace-progress")} style={{width: percent + '%'}} />
            </div>
        );
    }
}

export default connect((state) => {return {paces: state.app.pace}})(Pace);